import React from 'react';

const IndexPage = () => <div />;

export default IndexPage;
